/**
 * Application settings model representing the configuration structure
 */
export interface AppSettings {
  Api: {
    BaseUrl: string;
    ApigeeBaseUrl: string;
    ApiKey: string;
    TimeoutMs: number;
  };
  Auth: {
    IdentityServerUrl: string;
    AuthServerUrl: string;
    ClientId: string;
    RequireAuthentication: boolean;
    SkipAuthChecks: boolean;
  };
  App: {
    ClientUrl: string;
    BaseName: string;
    Environment: string;
  };
  Services: {
    UseMockServices: boolean;
    MockSettings: {
      SimulateNetworkDelay: boolean;
      MinDelayMs: number;
      MaxDelayMs: number;
    };
    RealTimeSettings: {
      DefaultRefreshIntervalMs: number;
    };
  };
  Features: {
    EnableRealTimeUpdates: boolean;
    EnableNotifications: boolean;
    EnableFileDownload: boolean;
    EnablePromoteButton: boolean;
  };
}

/**
 * Default app settings fallback values
 */
export const defaultAppSettings: AppSettings = {
  Api: {
    BaseUrl: "/api/",
    ApigeeBaseUrl: "",
    ApiKey: "",
    TimeoutMs: 30000
  },
  Auth: {
    IdentityServerUrl: "",
    AuthServerUrl: "",
    ClientId: "",
    RequireAuthentication: false,
    SkipAuthChecks: true
  },
  App: {
    ClientUrl: window.location.origin,
    BaseName: "/",
    Environment: "Development"
  },
  Services: {
    UseMockServices: true,
    MockSettings: {
      SimulateNetworkDelay: false,
      MinDelayMs: 300,
      MaxDelayMs: 1200
    },
    RealTimeSettings: {
      DefaultRefreshIntervalMs: 30000
    }
  },
  Features: {
    EnableRealTimeUpdates: true,
    EnableNotifications: false,
    EnableFileDownload: true,
    EnablePromoteButton: false
  }
};